import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Wrench, Eye, EyeOff, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Label } from '../components/ui/Label';
import { Checkbox } from '../components/ui/Checkbox';
export function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock login - just navigate to app
    navigate('/app');
  };
  return <div className="min-h-screen w-full flex bg-background" data-id="element-639">
      {/* Left Side - Hidden on mobile */}
      <div className="hidden lg:flex w-1/2 bg-card relative flex-col justify-between overflow-hidden border-r border-border" data-id="element-640">
        {/* Subtle gradient background */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-primary/20 via-background to-background" data-id="element-641" />

        <div className="relative z-10 p-12 flex items-center gap-2" data-id="element-642">
          <div className="bg-primary p-2 rounded-xl" data-id="element-643">
            <Wrench className="h-6 w-6 text-primary-foreground" data-id="element-644" />
          </div>
          <span className="font-heading font-bold text-xl tracking-tight" data-id="element-645">
            GarageFlow
          </span>
        </div>

        <div className="relative z-10 p-12 max-w-2xl" data-id="element-646">
          <blockquote className="space-y-6" data-id="element-647">
            <p className="text-3xl font-heading font-medium leading-tight" data-id="element-648">
              "A GarageFlow reduziu em 40% o tempo de atendimento na nossa
              oficina. O controle de estoque e as ordens de serviço integradas
              mudaram o nosso jogo."
            </p>
            <footer className="flex items-center gap-4" data-id="element-649">
              <div className="h-12 w-12 rounded-full bg-muted border border-border overflow-hidden" data-id="element-650">
                <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Carlos" alt="Carlos" data-id="element-651" />
              </div>
              <div data-id="element-652">
                <div className="font-semibold" data-id="element-653">Carlos Silva</div>
                <div className="text-sm text-muted-foreground" data-id="element-654">
                  Proprietário, Auto Center Premium
                </div>
              </div>
            </footer>
          </blockquote>
        </div>

        {/* Mock Dashboard Preview */}
        <div className="relative z-10 pl-12 pb-0 opacity-80 translate-y-12 translate-x-12 rotate-2" data-id="element-655">
          <div className="w-[800px] h-[400px] bg-background rounded-tl-2xl border-t border-l border-border shadow-2xl p-6 flex flex-col gap-4" data-id="element-656">
            <div className="flex gap-4" data-id="element-657">
              <div className="h-24 w-64 bg-card rounded-xl border border-border p-4 flex flex-col justify-between" data-id="element-658">
                <div className="w-20 h-4 bg-muted rounded" data-id="element-659" />
                <div className="w-32 h-8 bg-primary/20 rounded" data-id="element-660" />
              </div>
              <div className="h-24 w-64 bg-card rounded-xl border border-border p-4 flex flex-col justify-between" data-id="element-661">
                <div className="w-24 h-4 bg-muted rounded" data-id="element-662" />
                <div className="w-28 h-8 bg-emerald-500/20 rounded" data-id="element-663" />
              </div>
            </div>
            <div className="flex-1 bg-card rounded-xl border border-border p-4" data-id="element-664">
              <div className="w-full h-8 bg-muted rounded mb-4" data-id="element-665" />
              <div className="w-full h-12 bg-muted/50 rounded mb-2" data-id="element-666" />
              <div className="w-full h-12 bg-muted/50 rounded mb-2" data-id="element-667" />
              <div className="w-full h-12 bg-muted/50 rounded" data-id="element-668" />
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8" data-id="element-669">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="w-full max-w-[380px] space-y-8" data-id="element-670">
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left mb-8" data-id="element-671">
            <div className="lg:hidden bg-primary p-2 rounded-xl mb-6 inline-block" data-id="element-672">
              <Wrench className="h-6 w-6 text-primary-foreground" data-id="element-673" />
            </div>
            <h1 className="text-3xl font-heading font-bold tracking-tight mb-2" data-id="element-674">
              Bem-vindo de volta
            </h1>
            <p className="text-muted-foreground" data-id="element-675">
              Insira suas credenciais para acessar sua oficina.
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6" data-id="element-676">
            <div className="space-y-4" data-id="element-677">
              <div className="space-y-2" data-id="element-678">
                <Label htmlFor="email" data-id="element-679">E-mail</Label>
                <Input id="email" type="email" placeholder="contato@suaoficina.com.br" required className="h-12" data-id="element-680" />
              </div>
              <div className="space-y-2" data-id="element-681">
                <div className="flex items-center justify-between" data-id="element-682">
                  <Label htmlFor="password" data-id="element-683">Senha</Label>
                  <Link to="#" className="text-sm text-primary hover:underline font-medium" data-id="element-684">
                    Esqueci a senha
                  </Link>
                </div>
                <div className="relative" data-id="element-685">
                  <Input id="password" type={showPassword ? 'text' : 'password'} placeholder="••••••••" required className="h-12 pr-10" data-id="element-686" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors" data-id="element-687">
                    {showPassword ? <EyeOff className="h-5 w-5" data-id="element-688" /> : <Eye className="h-5 w-5" data-id="element-689" />}
                  </button>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-2" data-id="element-690">
              <Checkbox id="remember" data-id="element-691" />
              <Label htmlFor="remember" className="font-normal text-muted-foreground cursor-pointer" data-id="element-692">
                Lembrar de mim por 30 dias
              </Label>
            </div>

            <Button type="submit" className="w-full h-12 text-base font-medium" data-id="element-693">
              Entrar
            </Button>
          </form>

          <div className="relative" data-id="element-694">
            <div className="absolute inset-0 flex items-center" data-id="element-695">
              <span className="w-full border-t border-border" data-id="element-696" />
            </div>
            <div className="relative flex justify-center text-xs uppercase" data-id="element-697">
              <span className="bg-background px-2 text-muted-foreground" data-id="element-698">
                Ou
              </span>
            </div>
          </div>

          <Button variant="outline" className="w-full h-12 gap-2 font-medium" data-id="element-699">
            <svg className="h-5 w-5" viewBox="0 0 24 24" data-id="element-700">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-701" />
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-702" />
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-703" />
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-704" />
            </svg>
            Continuar com Google
          </Button>

          <p className="text-center text-sm text-muted-foreground" data-id="element-705">
            Não tem conta?{' '}
            <Link to="/onboarding" className="font-medium text-primary hover:underline" data-id="element-706">
              Criar oficina grátis
            </Link>
          </p>
        </motion.div>
      </div>
    </div>;
}